module.exports = __webpack_public_path__ + "img/NORDIC_MILK.4453b0ac.png";